<template>
<div class="mainCard">
<div class="transfercard">
  <div
  @click="navigate('transfer')"
    class="mx-auto card"
    width="205"
  >
     <img src="../assets/transfer.png" alt="teller logo" width="40" height="40">
     <div class="init">
        <h5>Transfer</h5>
        <small>Send and Recieve Money</small> 
     </div>
  </div>
</div>
<div class="AirTimecard">
  <div
    @click="navigate('airTime')"
    class="mx-auto card"
    width="205"
  >
     <img src="../assets/airTime.png" alt="teller logo" width="40" height="40">
     <div class="init">
        <h5>Airtime</h5>
        <small>Buy Airtime and Data</small> 
     </div>
  </div>
</div>
<div class="FRSCcard">
  <div
   @click="navigate('frsc')"
    class="mx-auto card"
    width="205"
  >
     <img src="../assets/frsc.png" alt="teller logo" width="40" height="40">
     <div class="init">
        <h5>FRSC</h5>
        <small>Pay FRSC Fees</small> 
     </div>
  </div>
</div>
<div class="Ecowascard">
  <div
   @click="navigate('jamb')"
    class="mx-auto card"
 width="205"
  >
     <img src="../assets/jamb.png" alt="teller logo" width="40" height="40">
     <div class="init">
        <h5>Jamb</h5>
        <small>Make Jamb Payments</small> 
     </div>
  </div>
</div>
<div class="Electricitycard">
  <div
   @click="navigate('electricity')"
    class="mx-auto card"
   width="205"
  >
     <img src="../assets/elect.png" alt="teller logo" width="40" height="40">
     <div class="init">
        <h5>Electricity</h5>
        <small>Pay Electricity Bills</small> 
     </div>
  </div>
</div>
<div class="NIScard">
  <div
    @click="navigate('nis')"
    class="mx-auto card"
     width="205"
  >
     <img src="../assets/NIS.png" alt="teller logo" width="40" height="40">
     <div class="init">
        <h5>NIS</h5>
        <small>Pay Immigration Fees</small> 
     </div>
  </div>
</div>
</div>
</template>
<script>
export default {
    methods: {
      navigate(to){
        this.$router.push({name: to})
      }
    },   
}
</script>
<style scoped>
@font-face {
font-family:'AvenirLTProMedium';
src: url('~@/assets/font/AvenirLTProMedium.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'AvenirLTProBookOblique';
src: url('~@/assets/font/AvenirLTProBookOblique.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'AvenirLTProHeavy';
src: url('~@/assets/font/AvenirLTProHeavy.otf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'FontsFree-Net-SFProDisplay-Regular';
src: url('~@/assets/font/FontsFree-Net-SFProDisplay-Regular.ttf');
font-weight: normal;
font-style: normal;
}

@font-face {
font-family:'SF-UI-Display-Bold';
src: url('~@/assets/font/SF-UI-Display-Bold.otf');
font-weight: normal;
font-style: normal;
}
@font-face {
font-family:'AvenirLTProBook';
src: url('~@/assets/font/AvenirLTProBook.otf');
font-weight: normal;
font-style: normal;
}
.mainCard{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(92px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
  "transfercard AirTimecard FRSCcard" 
  "Ecowascard Electricitycard NIScard" 
 ;
}
.transfercard{
     grid-area: transfercard;
}
.AirTimecard{
     grid-area: AirTimecard;
}
.FRSCcard{
     grid-area: FRSCcard;
}
.Ecowascard{
     grid-area: Ecowascard;
}
.Electricitycard{
     grid-area: Electricitycard;
}
.NIScard{
     grid-area: NIScard;
}
.card{
    display: flex;
    align-items: center;
    padding: 15px;
    cursor: pointer;
    margin: 5px;
    margin-right: 10px !important;
    border-radius: 5px !important;
    border-radius: 10px;
    box-shadow: 4px 12px 40px 0 rgba(189, 36, 91, 0.12);;
    background-color: #ffffff;
    
}
.init{
    margin-left: 5px;
}
h5{
  font-family: 'AvenirLTProBook';
  height: 22px;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
small{
  font-family: 'AvenirLTProBook';
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

@media only screen and (max-width: 700px) {
  .mainCard{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(92px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
  "transfercard transfercard transfercard"
  "AirTimecard AirTimecard AirTimecard"
  "FRSCcard FRSCcard FRSCcard" 
  "Ecowascard Ecowascard Ecowascard"
  "Electricitycard Electricitycard Electricitycard" 
  "NIScard NIScard NIScard" 
 ;
}
}
</style>